import { useTimezoneParam } from '@features/date-time';
import { useFilter } from '@features/table-filter';
import { useMerchantTestMode } from '@features/test-mode-toggler';
import { useRefetchCurrentPageData } from '@shared/hooks/useRefetchCurrentPageData';

import { useRequestWithdrawalQuery } from '../api';
import type { IRequestWithdrawalFilter } from '../model/types';

interface IProps {
  refreshInterval: string;
}

export const useRequestWithdrawals = ({ refreshInterval }: IProps) => {
  const filter = useFilter<IRequestWithdrawalFilter>();

  useTimezoneParam({ currentFilter: filter.currentFilter, updateFilter: filter.updateFilter });
  useMerchantTestMode({ currentFilter: filter.currentFilter, updateFilter: filter.updateFilter });
  const {
    data: requests,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  } = useRequestWithdrawalQuery(filter.currentFilter.toString(), {
    pollingInterval: refreshInterval === 'off' ? undefined : parseInt(refreshInterval),
  });

  // Refetch data when timezone changes
  useRefetchCurrentPageData({ refetch });

  return {
    requests,
    isError,
    error,
    isLoading,
    isFetching,
    refetch,

    filter,
  };
};
